// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"53bd1ea8","453":"68c2bce6","778":"8731ae97"}[chunkId] + ".chunk.js";
};